<template>
  <page-main :tableData="tableData" :loading="loading" :shipmentStatus="shipmentStatus" @reload="reload">
    <page-header
      ref="header"
      slot="header"
      :shipmentCode="shipmentCode"
      :shipmentStatus="shipmentStatus"
      @query="getData"
      @reset="resetPage"
    />
  </page-main>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain
  },
  mixins: [BaseTable],
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentStatus: { type: String }
  },
  data() {
    return {}
  },
  methods: {
    getData(form) {
      if (!this.shipmentCode) return
      this.loading = true
      this.$api
        .shipmentPackingListApi({
          shipmentCode: this.shipmentCode,
          ...form
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
